import Pikaday from 'pikaday';

// Datepicker
const dateFields = document.querySelectorAll('.datepicker');
if (dateFields) {
    const minimumDate = new Date();
    minimumDate.setDate(minimumDate.getDate() + 31); // minimum date, 31 days after today

    const datePickerOptions = {
        field: '',
        minDate: minimumDate,
        defaultDate: minimumDate,
        theme: 'custom-dp'
    };
    dateFields.forEach((element) => {
        datePickerOptions.field = element;
        new Pikaday(datePickerOptions);
        element.setAttribute('autocomplete', 'off');
    });
}